import { useGetCurrentTenantConfigQuery } from "features/me/meSlice";

// This component checks if a feature flag is enabled for the current tenant

export const TenantFeatureFlag = ({ featureFlagName = '', featureFlagNameList = [], children }) => {

    let { data: currentTenantConfig, error, isLoading } = useGetCurrentTenantConfigQuery();

    let featureAllowed = featureFlagName === '' && (featureFlagNameList?.length === 0 || featureFlagNameList?.some(flag => !flag));
    featureAllowed = featureAllowed || featureFlagNameList.some(flag =>  currentTenantConfig?.tenantFeatureFlags?.[flag] === true);
    featureAllowed = featureAllowed || currentTenantConfig?.tenantFeatureFlags?.[featureFlagName] === true;

    return featureAllowed ? <>{children}</> : <></>;
}
